import { render, staticRenderFns } from "./NeedEditElites.vue?vue&type=template&id=deb61fd2&scoped=true&"
import script from "./NeedEditElites.vue?vue&type=script&lang=js&"
export * from "./NeedEditElites.vue?vue&type=script&lang=js&"
import style0 from "./NeedEditElites.vue?vue&type=style&index=0&id=deb61fd2&prod&lang=css&"
import style1 from "./NeedEditElites.vue?vue&type=style&index=1&id=deb61fd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb61fd2",
  null
  
)

export default component.exports